const state = {
  invoiceOrderId: '',
  invoiceData: null,
  invoiceAmount: null,
  invoiceOtherCount: 0
}
const getters = {
  invoiceOrderId: state => state.invoiceOrderId,
  invoiceData: state => state.invoiceData,
  invoiceAmount: state => state.invoiceAmount,
  invoiceOtherCount: state => state.invoiceOtherCount
}

const mutations = {
  setInvoiceOrderId (state, val) {
    state.invoiceOrderId = val
  },
  setInvoiceData (state, val) {
    state.invoiceData = val
  },
  setInvoiceAmount (state, val) {
    state.invoiceAmount = val
  },
  setInvoiceOtherCount (state, val) {
    state.invoiceOtherCount = val
  },
}

export default {
  state,
  getters,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/invoice.js